import { Link } from "react-router-dom";
import { SaveBar } from "@/features/identity/components/SaveBar";
import { useProfileTheme } from "@/features/profiles/hooks/useProfileTheme";
import { ProfileThemeEditor, ThemeLoadState } from "@/features/profiles/components/ProfileThemeEditor";
import { ROUTES } from "@/constants/routes";

export default function ProfileThemeEditorPage() {
  const t = useProfileTheme();
  if (t.load.status !== "ready") return <ThemeLoadState t={t} />;

  const live = t.load.pp?.status === "published";
  const footer = (
    <>
      <div className="rounded-lg border border-border bg-card px-5 py-4"><SaveBar status={t.status} dirty={t.dirty} onSave={t.save} testId="profile-theme" /></div>
      <Link to={ROUTES.profileEditor} data-testid="profile-edit-identity-link" className="mw-link inline-block text-sm">Edit identity details</Link>
    </>
  );
  return (
    <div data-testid="profile-editor-page" className="mw-rise space-y-8">
      <header>
        <p className="mw-eyebrow">Public Profile</p>
        <h1 className="mt-3 font-serif text-4xl tracking-tight sm:text-5xl">Your public profile.</h1>
        <p className="mt-3 max-w-xl text-sm text-muted-foreground sm:text-base">One refined layout, built from your identity. Choose a theme color — we handle contrast and readability.</p>
      </header>
      {!t.load.card ? (
        <div data-testid="profile-needs-card" className="rounded-lg border border-dashed border-border p-6 text-sm">
          Save your card first — its link becomes your profile link. <Link to={ROUTES.card} className="mw-link">Go to My Card</Link>
        </div>
      ) : (
        <ProfileThemeEditor t={t} footer={footer} urlNote={live ? "Live. Theme changes show up right away." : undefined} />
      )}
    </div>
  );
}
